import { getManifest } from "lokalise"

export const setDocumentLanguageAndDirection = async (locale: string) => {
  const manifest = await getManifest()
  const isRTL = manifest.locales[locale]?.isRTL || false
  document.documentElement.lang = locale
  document.documentElement.dir = isRTL ? "rtl" : "ltr"
}

export const isRTL = (): boolean => {
  return document.documentElement.dir === "rtl"
}
